import { Observable } from "rxjs";

import { ProductsRepository } from "lib/repositories/index";
import st from "lib/utils/index";
import { createResourceInstance } from "modules/utils/index";
import { createAlert, removeAlert } from "modules/app/actions";

export const UPDATE_PRODUCT = "products/utils/UPDATE_PRODUCT";
export const UPDATE_PRODUCT_START = "products/utils/UPDATE_PRODUCT_START";
export const UPDATE_PRODUCT_SUCCESS = "products/utils/UPDATE_PRODUCT_SUCCESS";
export const UPDATE_PRODUCT_FAILURE = "products/utils/UPDATE_PRODUCT_FAILURE";

export const stateSelector = (state) => state.products.utils;

const updateProductResource = createResourceInstance({
  FETCH: UPDATE_PRODUCT,
  FETCH_START: UPDATE_PRODUCT_START,
  FETCH_SUCCESS: UPDATE_PRODUCT_SUCCESS,
  FETCH_FAILURE: UPDATE_PRODUCT_FAILURE,
  stateSelector,
  stateKey: "updateProduct",
  getModel: (state, store, { product }) => {
    return ProductsRepository.update(product);
  },
});

const initialState = {
  updateProduct: updateProductResource.initialState,
};

const reducers = {
  ...updateProductResource.reducersMap,
};

const epics = [
  ...updateProductResource.epics,

  (actions$) =>
    actions$.ofType(UPDATE_PRODUCT_START).map(({ params: { product } }) => {
      const alertUuid = `${UPDATE_PRODUCT_FAILURE}-${product.id}`;
      return removeAlert({ uuid: alertUuid });
    }),

  (actions$) =>
    actions$.ofType(UPDATE_PRODUCT_FAILURE).map(({ error, params: { product } }) => {
      const alertUuid = `${UPDATE_PRODUCT_FAILURE}-${product.id}`;
      return createAlert({
        uuid: alertUuid,
        type: "error",
        content: st.api.findResponseErrorMessage(error),
        timeout: false,
      });
    }),
];

export const { fetch: fetchUpdateProduct } = updateProductResource.actions;
export function updateProduct(product) {
  return fetchUpdateProduct({ product });
}

export default st.duck.createDuck(initialState, reducers, epics);



// WEBPACK FOOTER //
// ./src/modules/products/utils.js